import * as types from '@/components/Database/database.types';
import i18n from '@/plugins/i18n';
const databaseCBGraphs = () => ({
  lineCharts: [
    {
      width: '49%',
      title: i18n.global.t('dbm.cpuUsage'),
      header: {
        title: i18n.global.t('dbm.cpuUsage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_nodes_node_cpu_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.cpu-usage'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.cpu-usage'),
      },
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.ram-usage'),
      header: {
        title: i18n.global.t('dbm.ram-usage'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_nodes_node_ram_usage',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('ramUsage'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('ramUsage'),
      },
      aggregation: '/',
      aggregationNum: '1048576',
    },
  ],
  lineCharts2: [
    {
      width: '49%',
      title: i18n.global.t('dbm.swap-memory'),
      header: {
        title: i18n.global.t('dbm.swap-memory'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#29eeca'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_nodes_node_swap_mem_used',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.swap-memory-usage-mb'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.swap-memory-usage-mb'),
      },
      aggregation: '/',
      aggregationNum: '1048576',
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.node-operations'),
      header: {
        title: i18n.global.t('dbm.node-operations'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f', '#9bb6ff', '#29eeca'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName:
        'meter_couchbase_nodes_node_ops,meter_couchbase_nodes_node_hits,meter_couchbase_nodes_node_cmdget',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.count'),
      },
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.current-items'),
      header: {
        title: i18n.global.t('dbm.current-items'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f7507f'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_nodes_node_current_items',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-items'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-items'),
      },
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.node-replica'),
      header: {
        title: i18n.global.t('dbm.node-replica'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#fdfcac'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_nodes_node_replica_items',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.number-of-replicas'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.number-of-replicas'),
      },
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.docs-data-size'),
      header: {
        title: i18n.global.t('dbm.docs-data-size'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#ffa100'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_nodes_node_docs_data_size',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.document-size-mb'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.bytes'),
      },
      aggregation: '/',
      aggregationNum: '1048576',
    },
    {
      width: '49%',
      title: i18n.global.t('dbm.mcd-memory'),
      header: {
        title: i18n.global.t('dbm.mcd-memory'),
        titleIcon: '',
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#29eeca'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_couchbase_nodes_node_mcd_mem_allocated',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      unit: '',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.mcd-memory-usage-mb'),
      },
      labels: {
        xAxis: i18n.global.t('dbm.time'),
        yAxis: i18n.global.t('dbm.mcd-memory-usage-mb'),
      },
      aggregation: '/',
      aggregationNum: '1048576',
    },
  ],
  cardComponents: {
    width: '21.3%',
    cardName: [
      types.couchbaseCardNames.NODE_NAME,
      types.couchbaseCardNames.NODE_VERSION,
      types.couchbaseCardNames.NODE_STATUS,
      types.couchbaseCardNames.NODE_OS,
      types.couchbaseCardNames.NODE_UPTIME,
    ],
  },
});
export default databaseCBGraphs;
